export { default } from "./BoxRelatedTo"
